import { Link } from "react-router-dom";

const LINKS = [["/pricing", "Plans"], ["/legal/terms", "Terms"], ["/legal/privacy", "Privacy"], ["/legal/refunds", "Refunds & cancellation"]];

export function LegalLinks() {
  return (
    <nav data-testid="legal-links" className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-ink-3">
      {LINKS.map(([to, l]) => <Link key={to} to={to} data-testid={`legal-link-${to.split("/").pop()}`} className="hover:text-ink hover:underline">{l}</Link>)}
      <a href="mailto:info@iddcrinstitute.com" data-testid="legal-link-contact" className="hover:text-ink hover:underline">Contact: info@iddcrinstitute.com</a>
    </nav>
  );
}
